var React = require('react');

function Effacer (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"8","fill":"#CECECE","key":0}),React.createElement("path",{"d":"M9.5 9.5L14.5 14.5","stroke":"#555555","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M9.5 14.5L14.5 9.5","stroke":"#555555","strokeWidth":"1.5","strokeLinecap":"round","key":2})]);
}

Effacer.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Effacer;

Effacer.default = Effacer;
